export default "__VITE_ASSET__43c102e3__"